module.exports = "/cyber/_next/static/images/promoInarius-dab7e15bff51a0668fb94c3494ffba75.jpg";